import { ChangeDetectionStrategy, Component } from '@angular/core';
@Component({
    selector: 'app-health-check',
    templateUrl: './health-check.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class HealthCheckComponent {
    constructor() {}
}
